
import TransferDom from 'vux/src/directives/transfer-dom/index.js'

import {
sendcommand,
sendcommandmessage,
set902device,
setdevice,
setdevicenotify,
setdevicenotifytype,
updatedevice
} from '../../api/device'
export default {
name: 'NewSubDeviceDetail',
directives: {
TransferDom
},
data () {
return {
deviceObj: '',

resultWay: [], // 通知方式
infoValues: [
{type: 'batteryPercent', name: '电池电量(%)', dTypes: [906, 920]},
{type: 'outputVol', name: '输出电压(V)', dTypes: [906, 920]},
{type: 'voltage', name: '电压(V)', dTypes: [301, 402, 404, 503, 504, 505, 506, 507, 508, 509, 510, 511, 537, 538, 543, 753, 904, 905]},
{type: 'battery', name: '电量(%)', dTypes: [503, 545, 751, 901]},
{type: 'temperature', name: '温度(℃)', dTypes: [301, 504, 506, 507, 508, 509, 510, 511, 537, 538, 543, 904, 905, 751]},
{type: 'humidity', name: '湿度(%)', dTypes: [751]},
{type: 'signal', name: '信号', dTypes: [402, 404, 504, 505, 506, 507, 508, 509, 510, 511, 537, 538, 543, 752, 780, 408, 904, 905]},
{type: 'probeTempHum1', name: '探头1', dTypes: [753]},
{type: 'probeTempHum2', name: '探头2', dTypes: [753]},
{type: 'probeTempHum3', name: '探头3', dTypes: []},
{type: 'probeTempHum4', name: '探头4', dTypes: []}
],
showInfoValues: [], // 信息数据(限制三个【左中右】 需优化)

setting: '',
showDisabled: false, // 分享的设备不给操作
setShow: false, // 设置弹窗
setObj: {
title: '',
type: '',


checkHighTemperature: null,
checkLowTemperature: null,
highTemperature: '',
lowTemperature: '',

checkHighHumidity: null,
checkLowHumidity: null,
highHumidity: '',
lowHumidity: '',

residenceTime: '',

installHeight: '',

devicePhone: '',

sosPhone: '',

phone1: '',

name1: '',

phone2: '',

name2: '',

alarmPhone: '',

notifyContent: '',

notify: '',

notifyOpenDoor: '',

notifyCloseDoor: '',

notifyExist: '',

notifyNotExist: '',

outputStatus: '',

heartbeatDuration: ''
},
activityShow: false, // 无活动报警弹窗
activityObj: {
activity: '',
hourArr: [{text: 0}, {text: 1}, {text: 2}, {text: 3}, {text: 4}, {text: 5}, {text: 6}, {text: 7}, {text: 8}, {text: 9}, {text: 10}, {text: 11}, {text: 12},
{text: 13}, {text: 14}, {text: 15}, {text: 16}, {text: 17}, {text: 18}, {text: 19}, {text: 20}, {text: 21}, {text: 22}, {text: 23}],
minuteArr: [{text: 0}, {text: 10}, {text: 20}, {text: 30}, {text: 40}, {text: 50}],

periodHourShow: false,
periodHour: '',
periodHourIdx: 0,
periodMinuteShow: false,
periodMinute: '',
periodMinuteIdx: 0,

durationStartShow: false,
durationStart: '',
durationStartIdx: 0,
durationEndShow: false,
durationEnd: '',
durationEndIdx: 0,

hintShow: false,
hintText: '第二个字段要么为0，要么大于第一个字段值。'
},
setListShow: false, // 设置列表弹窗
setListObj: {
title: '',
type: '',
isList: true,
editIdx: '',
hintShow: false,
hintText: '',


phoneBookObj: {
name: '',
phone: '',
icon: 'http://baidu.com',
im: ''
},
phoneBookList: [],

fmObj: {
name: '',
frequency: ''
},
fmList: []
}
}
},
created () {
this.getStartData()
},
methods: {
mqttChange (device) {
this.deviceObj = device
},
getStartData () {
this.deviceObj = this.$store.getters.get_child_obj
this.setting = this.deviceObj.settingObj
this.infoValues.filter(r => r.dTypes.indexOf(this.deviceObj.dtype) >= 0).forEach((item, index) => {
let idx = parseInt(index / 3)
if (!this.showInfoValues[idx]) {
this.showInfoValues[idx] = []
}
this.showInfoValues[idx].push(item)
})
this.showDisabled = this.deviceObj.phonedevicerole !== 'admin'




if (this.deviceObj.dtype === 401 || this.deviceObj.dtype === 402 || this.deviceObj.dtype === 404 ||
this.deviceObj.dtype === 504 || this.deviceObj.dtype === 508 || this.deviceObj.dtype === 509 ||
this.deviceObj.dtype === 538 || this.deviceObj.dtype === 543) {
this.setObj.notifyOpenDoor = this.deviceObj.notify === 1 || this.deviceObj.notify === 2
this.setObj.notifyCloseDoor = this.deviceObj.notify === 1 || this.deviceObj.notify === 3
} else if (this.deviceObj.dtype === 507 || this.deviceObj.dtype === 545) {
this.setObj.notify = this.deviceObj.notify === 1
} else if (this.deviceObj.dtype === 405 || this.deviceObj.dtype === 406 || this.deviceObj.dtype === 407 || this.deviceObj.dtype === 408 ||
this.deviceObj.dtype === 752 || this.deviceObj.dtype === 780) {
this.setObj.notifyExist = this.deviceObj.notify === 1 || this.deviceObj.notify === 2
this.setObj.notifyNotExist = this.deviceObj.notify === 1 || this.deviceObj.notify === 3
}
this.resultWay = this.getNotifyWay()
},
getNotifyWay () {





let wayArr = []
let notifyType = this.deviceObj.notifytype.split('')
if (notifyType[0] === '1') {
wayArr.push('1')
}
if (notifyType[1] === '1') {
wayArr.push('2')
}
if (notifyType[2] === '1') {
wayArr.push('3')
}
return wayArr
},

changeWaySend () {
let way = '000'
let notifyType = this.deviceObj.notifytype
for (let i = 0; i < this.resultWay.length; i++) {
if (this.resultWay[i] === '1') {
way = '1' + way.slice(1)
} else if (this.resultWay[i] === '2') {
way = way.slice(0, 1) + '1' + way.slice(2)
} else if (this.resultWay[i] === '3') {
way = way.slice(0, 2) + '1'
}
}
notifyType = way + notifyType.slice(3)
let data = {
phone: this.$store.getters.get_user,
did: this.deviceObj.id,
notifytype: notifyType
}

setdevicenotifytype(data).then(res => {
if (res.code === 200) {
this.deviceObj.notifytype = notifyType
this.$toast('成功')
} else {
this.$toast('失败')
this.resultWay = this.getNotifyWay()
}
}).catch(() => {
this.$toast('失败')
this.resultWay = this.getNotifyWay()
})
},
periodHourConfirm (obj) {
this.activityObj.periodHour = obj.text
this.activityObj.periodHourShow = false
},
periodMinuteConfirm (obj) {
this.activityObj.periodMinute = obj.text
this.activityObj.periodMinuteShow = false
},
durationStartConfirm (obj) {
this.activityObj.durationStart = obj.text
this.activityObj.durationStartShow = false
},
durationEndConfirm (obj) {
this.activityObj.durationEnd = obj.text
if (this.activityObj.durationEnd !== 0 && this.activityObj.durationEnd < this.activityObj.durationStart) {
this.activityObj.hintShow = true
this.activityObj.hintText = '第二个监测时段要么为0时，要么大于第一个监测时段。'
this.activityObj.durationEnd = ''
}
this.activityObj.durationEndShow = false
},

openSetTemperature (type) {
this.setObj.type = type
let title = this.deviceObj.dtype === 753 ? '探头1温度预警设置' : '温度预警设置'
if (type === 'temperature') {
this.setObj.highTemperature = this.setting.highTemperature && this.setting.highTemperature !== '' ? this.setting.highTemperature : '40'
this.setObj.lowTemperature = this.setting.lowTemperature && this.setting.lowTemperature !== '' ? this.setting.lowTemperature : '3'
} else if (type === 'temperature2') {
title = '探头2温度预警设置'
this.setObj.highTemperature = this.setting.highTemperature2 && this.setting.highTemperature2 !== '' ? this.setting.highTemperature2 : '40'
this.setObj.lowTemperature = this.setting.lowTemperature2 && this.setting.lowTemperature2 !== '' ? this.setting.lowTemperature2 : '3'
}

if (this.deviceObj.dtype === 301 || this.deviceObj.dtype === 753 || this.deviceObj.dtype === 904 || this.deviceObj.dtype === 905) {
if (type === 'temperature') {
this.setObj.checkHighTemperature = this.setting.highTemperature && this.setting.highTemperature !== '' ? ['1'] : []
this.setObj.checkLowTemperature = this.setting.lowTemperature && this.setting.lowTemperature !== '' ? ['1'] : []
} else if (type === 'temperature2') {
this.setObj.checkHighTemperature = this.setting.highTemperature2 && this.setting.highTemperature2 !== '' ? ['1'] : []
this.setObj.checkLowTemperature = this.setting.lowTemperature2 && this.setting.lowTemperature2 !== '' ? ['1'] : []
}
}
this.setObj.title = title
this.setShow = true
},
openSetHumidity (type) {
this.setObj.type = type
let title = this.deviceObj.dtype === 753 ? '探头1湿度预警设置' : '湿度预警设置'
if (type === 'humidity') {
this.setObj.highHumidity = this.setting.highHumidity && this.setting.highHumidity !== '' ? this.setting.highHumidity : '99'
this.setObj.lowHumidity = this.setting.lowHumidity && this.setting.lowHumidity !== '' ? this.setting.lowHumidity : '0'
} else if (type === 'humidity2') {
title = '探头2湿度预警设置'
this.setObj.highHumidity = this.setting.highHumidity2 && this.setting.highHumidity2 !== '' ? this.setting.highHumidity2 : '99'
this.setObj.lowHumidity = this.setting.lowHumidity2 && this.setting.lowHumidity2 !== '' ? this.setting.lowHumidity2 : '0'
}

if (this.deviceObj.dtype === 753) {
if (type === 'humidity') {
this.setObj.checkHighHumidity = this.setting.highHumidity && this.setting.highHumidity !== '' ? ['1'] : []
this.setObj.checkLowHumidity = this.setting.lowHumidity && this.setting.lowHumidity !== '' ? ['1'] : []
} else if (type === 'humidity2') {
this.setObj.checkHighHumidity = this.setting.highHumidity2 && this.setting.highHumidity2 !== '' ? ['1'] : []
this.setObj.checkLowHumidity = this.setting.lowHumidity2 && this.setting.lowHumidity2 !== '' ? ['1'] : []
}
}
this.setObj.title = title
this.setShow = true
},
openSetResidenceTime () {
this.setObj.title = '滞留预警时长设置'
this.setObj.type = 'residenceTime'
this.setObj.residenceTime = this.setting.residenceTime && this.setting.residenceTime !== '' && this.setting.residenceTime !== 0 ? this.setting.residenceTime : '5'
this.setShow = true
},
openSetInstallHeight () {
this.setObj.title = '安装高度设置'
this.setObj.type = 'installHeight'
this.setObj.installHeight = this.setting.installHeight && this.setting.installHeight !== '' ? this.setting.installHeight : '230'
this.setShow = true
},
openSetDevicePhone () {
this.setObj.title = '设置本机号码'
this.setObj.type = 'devicePhone'
this.setObj.devicePhone = this.deviceObj.devicephone
this.setShow = true
},
openSetSosPhone () {
this.setObj.title = '设置SOS号码'
this.setObj.type = 'sosPhone'
this.setObj.sosPhone = this.setting.sosPhone ? this.setting.sosPhone : ''
this.setShow = true
},
openSetButton1 () {
this.setObj.title = '设置按钮一号码'
this.setObj.type = 'phone1'
this.setObj.phone1 = this.setting.phone1 ? this.setting.phone1 : ''
this.setObj.name1 = this.setting.name1 ? this.setting.name1 : '号码一'
this.setShow = true
},
openSetButton2 () {
this.setObj.title = '设置按钮二号码'
this.setObj.type = 'phone2'
this.setObj.phone2 = this.setting.phone2 ? this.setting.phone2 : ''
this.setObj.name2 = this.setting.name2 ? this.setting.name2 : '号码二'
this.setShow = true
},
openSetNotifyContent () {
this.setObj.title = '设置闪屏通知'
this.setObj.type = 'notifyContent'
this.setObj.notifyContent = this.setting.notifyContent ? this.setting.notifyContent : ''
this.setShow = true
},
openSetAlarmPhone () {
this.setObj.title = '设置报警号码'
this.setObj.type = 'alarmPhone'
this.setObj.alarmPhone = this.setting.alarmPhone ? this.setting.alarmPhone : ''
this.setShow = true
},
openPhoneBookList () {
this.setListObj.title = '通讯录'
this.setListObj.type = 'phoneBook'
this.setListObj.isList = true
this.setListObj.phoneBookList = this.setting.phoneBookList ? this.setting.phoneBookList : []
this.setListShow = true
},
openSetPhoneBook (item, index) {
this.setListObj.phoneBookObj.name = item ? item.name : ''
this.setListObj.phoneBookObj.phone = item ? item.phone : ''
this.setListObj.phoneBookObj.im = item ? item.im : ''
this.setListObj.phoneBookObj.icon = item ? item.icon : 'http://baidu.com'
if (index) {
this.setListObj.editIdx = index
} else {
this.setListObj.editIdx = -1
}
this.setListObj.isList = false
},
openFMList () {
this.setListObj.title = 'FM频率'
this.setListObj.type = 'fm'
this.setListObj.isList = true
this.setListObj.fmList = this.setting.fmList ? this.setting.fmList : []
this.setListShow = true
},
openSetFM (item, index) {
this.setListObj.fmObj.name = item ? item.name : ''
this.setListObj.fmObj.frequency = item ? item.frequency : ''
if (index) {
this.setListObj.editIdx = index
} else {
this.setListObj.editIdx = -1
}
this.setListObj.isList = false
},
openSetActivity () {
this.activityObj.activity = this.setting.isActivity
if (this.activityObj.activity === true) {
this.activityObj.periodHour = this.setting.periodHour
this.activityObj.periodMinute = this.setting.periodMinute
this.activityObj.durationStart = this.setting.durationStart
this.activityObj.durationEnd = this.setting.durationEnd
this.activityObj.hourArr.forEach((hour, index) => {
if (parseInt(this.activityObj.periodHour) === hour.text) {
this.activityObj.periodHourIdx = index
}
if (parseInt(this.activityObj.durationStart) === hour.text) {
this.activityObj.durationStartIdx = index
}
if (parseInt(this.activityObj.durationEnd) === hour.text) {
this.activityObj.durationEndIdx = index
}
})
this.activityObj.minuteArr.forEach((minute, index) => {
if (parseInt(this.activityObj.periodMinute) === minute.text) {
this.activityObj.periodMinuteIdx = index
}
})
} else {
this.activityObj.periodHour = ''
this.activityObj.periodMinute = ''
this.activityObj.durationStart = ''
this.activityObj.durationEnd = ''
this.activityObj.periodHourIdx = 0
this.activityObj.periodMinuteIdx = 0
this.activityObj.durationStartIdx = 0
this.activityObj.durationEndIdx = 0
}
this.activityShow = true
},
openSetOutputStatus () {
this.setObj.title = '输出设置'
this.setObj.type = 'outputStatus'
this.setObj.outputStatus = this.setting.outputStatus ? this.setting.outputStatus : ''
this.setShow = true
},
openSetHeartbeatDuration () {
this.setObj.title = '心跳设置'
this.setObj.type = 'heartbeatDuration'
this.setObj.heartbeatDuration = this.setting.heartbeatDuration ? this.setting.heartbeatDuration : ''
this.setShow = true
},

submitSet () {
let type = this.setObj.type
if (type === 'temperature' || type === 'temperature2') {
this.submitTemperature(this.setObj, type)
} else if (type === 'humidity' || type === 'humidity2') {
this.submitHumidity(this.setObj, type)
} else if (type === 'residenceTime') {
this.submitResidenceTime(this.setObj)
} else if (type === 'installHeight') {
this.submitInstallHeight(this.setObj)
} else if (type === 'devicePhone') {
this.submitDevicePhone(this.setObj)
} else if ((this.deviceObj.dtype === 902 || this.deviceObj.dtype === 701) && (type === 'sosPhone' || type === 'phone1' || type === 'phone2')) {
this.submitPhone902(this.setObj)
} else if (this.deviceObj.dtype === 701 && type === 'notifyContent') {
this.submitNotify701(this.setObj)
} else if (type === 'alarmPhone') {
this.submitAlarmPhone(this.setObj)
} else if (type === 'outputStatus') {
this.submitOutputStatus(this.setObj)
} else if (type === 'heartbeatDuration') {
this.submitHeartbeatDuration(this.setObj)
}
},
submitTemperature (setObj, type) {
if (setObj.checkHighTemperature && setObj.checkLowTemperature) {
if (setObj.checkHighTemperature[0] && setObj.highTemperature === '') {
this.$toast('请设置高温预警阈值')
return
}
if (setObj.checkLowTemperature[0] && setObj.lowTemperature === '') {
this.$toast('请设置低温预警阈值')
return
}
let cmd = ''
let curCmd = (setObj.checkLowTemperature.length > 0 ? setObj.checkLowTemperature[0] : 0) +
'|' + (setObj.checkHighTemperature.length > 0 ? setObj.checkHighTemperature[0] : 0) +
'|' + (setObj.checkLowTemperature.length > 0 ? setObj.lowTemperature : 0) +
'|' + (setObj.checkHighTemperature.length > 0 ? setObj.highTemperature : 0)
if (this.deviceObj.dtype === 753) {
let temperatureCmd = (this.setting && this.setting.isLowTemerature ? 1 : 0) +
'|' + (this.setting && this.setting.isHighTemerature ? 1 : 0) +
'|' + (this.setting && this.setting.lowTemperature ? this.setting.lowTemperature : '') +
'|' + (this.setting && this.setting.highTemperature ? this.setting.highTemperature : '')
let temperature2Cmd = (this.setting && this.setting.isLowTemerature2 ? 1 : 0) +
'|' + (this.setting && this.setting.isHighTemerature2 ? 1 : 0) +
'|' + (this.setting && this.setting.lowTemperature2 ? this.setting.lowTemperature2 : '') +
'|' + (this.setting && this.setting.highTemperature2 ? this.setting.highTemperature2 : '')
let humidityCmd = (this.setting && this.setting.isLowHumidity ? 1 : 0) +
'|' + (this.setting && this.setting.isHighHumidity ? 1 : 0) +
'|' + (this.setting && this.setting.lowHumidity ? this.setting.lowHumidity : '') +
'|' + (this.setting && this.setting.highHumidity ? this.setting.highHumidity : '')
let humidity2Cmd = (this.setting && this.setting.isLowHumidity2 ? 1 : 0) +
'|' + (this.setting && this.setting.isHighHumidity2 ? 1 : 0) +
'|' + (this.setting && this.setting.lowHumidity2 ? this.setting.lowHumidity2 : '') +
'|' + (this.setting && this.setting.highHumidity2 ? this.setting.highHumidity2 : '')
if (type === 'temperature') {
cmd = curCmd + '#' + humidityCmd + '&' + temperature2Cmd + '#' + humidity2Cmd
} else if (type === 'temperature2') {
cmd = temperatureCmd + '#' + humidityCmd + '&' + curCmd + '#' + humidity2Cmd
}
} else {
cmd = curCmd
}
let data = {
did: this.deviceObj.id,
cmd: cmd
}
sendcommand(data).then(res => {
if (type === 'temperature') {
this.setting.isHighTemerature = setObj.checkHighTemperature.length > 0
this.setting.isLowTemerature = setObj.checkLowTemperature.length > 0
this.setting.highTemperature = setObj.checkHighTemperature.length > 0 ? setObj.highTemperature : ''
this.setting.lowTemperature = setObj.checkLowTemperature.length > 0 ? setObj.lowTemperature : ''
} else if (type === 'temperature2') {
this.setting.isHighTemerature2 = setObj.checkHighTemperature.length > 0
this.setting.isLowTemerature2 = setObj.checkLowTemperature.length > 0
this.setting.highTemperature2 = setObj.checkHighTemperature.length > 0 ? setObj.highTemperature : ''
this.setting.lowTemperature2 = setObj.checkLowTemperature.length > 0 ? setObj.lowTemperature : ''
}
this.$toast('成功发送指令')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false

}).catch(() => {})
} else {
if (setObj.highTemperature === '') {
this.$toast('请设置高温预警阈值')
return
}
if (setObj.lowTemperature === '') {
this.$toast('请设置低温预警阈值')
return
}
if (parseFloat(setObj.highTemperature) > 60 || parseFloat(setObj.lowTemperature) < 0) {
this.$toast('温度设置范围 0℃~60℃。')
return
}
let command = {
imei: this.deviceObj.deviceid,
did: this.deviceObj.id,
method: 'settemphumidity',
command1: setObj.highTemperature,
command2: setObj.lowTemperature,
command3: this.setting.highHumidity,
command4: this.setting.lowHumidity
}
sendcommandmessage(command).then(res => {
this.setting.highTemperature = setObj.highTemperature
this.setting.lowTemperature = setObj.lowTemperature
this.$toast('设置成功后，将在同步设备后正式生效(1小时以内)')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false
})
}
},
submitHumidity (setObj, type) {
if (setObj.checkHighHumidity && setObj.checkLowHumidity) {
if (setObj.checkHighHumidity[0] && setObj.highHumidity === '') {
this.$toast('请设置高湿预警阈值')
return
}
if (setObj.checkLowHumidity[0] && setObj.lowHumidity === '') {
this.$toast('请设置低湿预警阈值')
return
}
let cmd = ''
let curCmd = (setObj.checkLowHumidity.length > 0 ? setObj.checkLowHumidity[0] : 0) +
'|' + (setObj.checkHighHumidity.length > 0 ? setObj.checkHighHumidity[0] : 0) +
'|' + (setObj.checkLowHumidity.length > 0 ? setObj.lowHumidity : 0) +
'|' + (setObj.checkHighHumidity.length > 0 ? setObj.highHumidity : 0)
if (this.deviceObj.dtype === 753) {
let temperatureCmd = (this.setting && this.setting.isLowTemerature ? 1 : 0) +
'|' + (this.setting && this.setting.isHighTemerature ? 1 : 0) +
'|' + (this.setting && this.setting.lowTemperature ? this.setting.lowTemperature : '') +
'|' + (this.setting && this.setting.highTemperature ? this.setting.highTemperature : '')
let temperature2Cmd = (this.setting && this.setting.isLowTemerature2 ? 1 : 0) +
'|' + (this.setting && this.setting.isHighTemerature2 ? 1 : 0) +
'|' + (this.setting && this.setting.lowTemperature2 ? this.setting.lowTemperature2 : '') +
'|' + (this.setting && this.setting.highTemperature2 ? this.setting.highTemperature2 : '')
let humidityCmd = (this.setting && this.setting.isLowHumidity ? 1 : 0) +
'|' + (this.setting && this.setting.isHighHumidity ? 1 : 0) +
'|' + (this.setting && this.setting.lowHumidity ? this.setting.lowHumidity : '') +
'|' + (this.setting && this.setting.highHumidity ? this.setting.highHumidity : '')
let humidity2Cmd = (this.setting && this.setting.isLowHumidity2 ? 1 : 0) +
'|' + (this.setting && this.setting.isHighHumidity2 ? 1 : 0) +
'|' + (this.setting && this.setting.lowHumidity2 ? this.setting.lowHumidity2 : '') +
'|' + (this.setting && this.setting.highHumidity2 ? this.setting.highHumidity2 : '')
if (type === 'humidity') {
cmd = temperatureCmd + '#' + curCmd + '&' + temperature2Cmd + '#' + humidity2Cmd
} else if (type === 'humidity2') {
cmd = temperatureCmd + '#' + humidityCmd + '&' + temperature2Cmd + '#' + curCmd
}
} else {
cmd = curCmd
}
let data = {
did: this.deviceObj.id,
cmd: cmd
}
sendcommand(data).then(res => {
if (type === 'humidity') {
this.setting.isHighHumidity = setObj.checkHighHumidity.length > 0
this.setting.isLowHumidity = setObj.checkLowHumidity.length > 0
this.setting.highHumidity = setObj.checkHighHumidity.length > 0 ? setObj.highHumidity : ''
this.setting.lowHumidity = setObj.checkLowHumidity.length > 0 ? setObj.lowHumidity : ''
} else if (type === 'humidity2') {
this.setting.isHighHumidity2 = setObj.checkHighHumidity.length > 0
this.setting.isLowHumidity2 = setObj.checkLowHumidity.length > 0
this.setting.highHumidity2 = setObj.checkHighHumidity.length > 0 ? setObj.highHumidity : ''
this.setting.lowHumidity2 = setObj.checkLowHumidity.length > 0 ? setObj.lowHumidity : ''
}
this.$toast('成功发送指令')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false

}).catch(() => {})
} else {
if (setObj.highHumidity === '') {
this.$toast('请设置高湿预警阈值')
return
}
if (setObj.lowHumidity === '') {
this.$toast('请设置低湿预警阈值')
return
}
if (parseFloat(setObj.highHumidity) > 99 || parseFloat(setObj.lowHumidity) < 0) {
this.$toast('湿度设置范围 0~99。')
return
}
let command = {
imei: this.deviceObj.deviceid,
did: this.deviceObj.id,
method: 'settemphumidity',
command1: this.setting.highTemperature,
command2: this.setting.lowTemperature,
command3: setObj.highHumidity,
command4: setObj.lowHumidity
}
sendcommandmessage(command).then(res => {
this.setting.highHumidity = setObj.highHumidity
this.setting.lowHumidity = setObj.lowHumidity
this.$toast('设置成功后，将在同步设备后正式生效(1小时以内)')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false
})
}
},
submitResidenceTime (setObj) {
if (setObj.residenceTime === '') {
this.$toast('请设置滞留预警时长')
return
}
let command = {
imei: this.deviceObj.deviceid,
did: this.deviceObj.id,
method: 'setstatus',
command1: 'residence_time',
command2: setObj.residenceTime * 60 + '',
command3: '',
command4: ''
}
sendcommandmessage(command).then(res => {
this.setting.residenceTime = setObj.residenceTime
this.$toast('设置成功')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false
})
},
submitInstallHeight (setObj) {
if (setObj.installHeight === '') {
this.$toast('请设置安装高度')
return
}
if (setObj.installHeight < 150 || setObj.installHeight > 500) {
this.$toast('请输入150~500之间')
return
}
let command = {
imei: this.deviceObj.deviceid,
did: this.deviceObj.id,
method: 'setinstallheight',
command1: setObj.installHeight,
command2: '',
command3: '',
command4: ''
}
sendcommandmessage(command).then(res => {
this.setting.installHeight = setObj.installHeight
this.$toast('设置成功')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false
})
},
submitDevicePhone (setObj) {
let data = {
did: parseInt(this.deviceObj.id),
name: this.deviceObj.name,
devicephone: setObj.devicePhone
}
updatedevice(data).then(res => {
if (res.code === 200) {
this.deviceObj.devicephone = setObj.devicePhone
this.$toast('设置成功')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false
} else {
this.$toast(res.msg)
}
}).catch(() => {
this.$toast('设置失败')
})
},
submitPhone902 (setObj) {
let data = {
imei: this.deviceObj.deviceid,
sosphone: this.setting.sosPhone,
phone1: this.setting.phone1,
name1: this.setting.name1,
phone2: this.setting.phone2,
name2: this.setting.name2
}
if (setObj.type === 'sosPhone') {
data.flag = 'sos'
data.sosphone = setObj.sosPhone
} else if (setObj.type === 'phone1') {
data.flag = 'button'
data.phone1 = setObj.phone1
data.name1 = setObj.name1
} else if (setObj.type === 'phone2') {
data.flag = 'button'
data.phone2 = setObj.phone2
data.name2 = setObj.name2
}
set902device(data).then(res => {
if (res.code === 200) {
this.setting.sosPhone = setObj.type === 'sosPhone' ? setObj.sosPhone : this.setting.sosPhone
this.setting.phone1 = setObj.type === 'phone1' ? setObj.phone1 : this.setting.phone1
this.setting.name1 = setObj.type === 'phone1' ? setObj.name1 : this.setting.name1
this.setting.phone2 = setObj.type === 'phone2' ? setObj.phone2 : this.setting.phone2
this.setting.name2 = setObj.type === 'phone2' ? setObj.name2 : this.setting.name2
this.$toast('设置成功')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false
} else {
this.$toast(res.msg)
}
}).catch(() => {
this.$toast('设置失败')
})
},
submitNotify701 (setObj) {
let command = {
imei: this.deviceObj.deviceid,
did: this.deviceObj.id,
method: 'sendmessage310',
command1: '1',
command2: setObj.notifyContent
}
sendcommandmessage(command).then(res => {
this.setting.notifyContent = setObj.notifyContent
this.$toast('设置成功')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false
})
},
submitAlarmPhone (setObj) {
let data = {
imei: this.deviceObj.deviceid,
did: this.deviceObj.id,
method: 'setalarmcallphone',
command1: setObj.alarmPhone,
command2: '',
command3: '',
command4: '',
command5: '',
reserved1: '',
reserved2: ''
}
sendcommandmessage(data).then(res => {
if (res.code === 200) {
this.setting.alarmPhone = setObj.alarmPhone
this.$toast('设置成功')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false
} else {
this.$toast('设置失败')
}
}).catch(() => {
this.$toast('设置失败')
})
},
submitNotify () {
let data = {
did: this.deviceObj.id,
notify: this.setObj.notify ? 1 : 0
}
setdevicenotify(data).then(res => {
if (res.code === 200) {
this.$toast(this.setObj.notify ? '布防成功' : '撤防成功')
this.deviceObj.notify = data.notify
this.$store.commit('set_child_obj', this.deviceObj)
} else {
this.$toast(this.setObj.notify ? '布防失败' : '撤防失败')
this.setObj.notify = !this.setObj.notify
}
}).catch(() => {
this.$toast(this.setObj.notify ? '布防失败' : '撤防失败')
this.setObj.notify = !this.setObj.notify
})
},
submitNotifyOpenDoor () {
this.submitNotifyDoor('openDoor')
},
submitNotifyCloseDoor () {
this.submitNotifyDoor('closeDoor')
},
submitNotifyDoor (type) {
let data = {did: this.deviceObj.id, notify: 0}
if (!this.setObj.notifyOpenDoor && !this.setObj.notifyCloseDoor) {
data.notify = 0 
} else if (this.setObj.notifyOpenDoor && this.setObj.notifyCloseDoor) {
data.notify = 1 
} else if (this.setObj.notifyOpenDoor && !this.setObj.notifyCloseDoor) {
data.notify = 2 
} else if (!this.setObj.notifyOpenDoor && this.setObj.notifyCloseDoor) {
data.notify = 3 
}
setdevicenotify(data).then(res => {
if (res.code === 200) {
this.$toast('操作成功')
this.deviceObj.notify = data.notify
this.$store.commit('set_child_obj', this.deviceObj)
} else {
this.$toast('操作失败')
if (type === 'openDoor') {
this.setObj.notifyOpenDoor = !this.setObj.notifyOpenDoor
} else if (type === 'closeDoor') {
this.setObj.notifyCloseDoor = !this.setObj.notifyCloseDoor
}
}
}).catch(() => {
this.$toast('操作失败')
if (type === 'openDoor') {
this.setObj.notifyOpenDoor = !this.setObj.notifyOpenDoor
} else if (type === 'closeDoor') {
this.setObj.notifyCloseDoor = !this.setObj.notifyCloseDoor
}
})
},
submitNotifyExist () {
this.submitNotifyHumanExist('exist')
},
submitNotifyNotExist () {
this.submitNotifyHumanExist('notExist')
},
submitNotifyHumanExist (type) {
let data = {did: this.deviceObj.id, notify: 0}
if (!this.setObj.notifyExist && !this.setObj.notifyNotExist) {
data.notify = 0 
} else if (this.setObj.notifyExist && this.setObj.notifyNotExist) {
data.notify = 1 
} else if (this.setObj.notifyExist && !this.setObj.notifyNotExist) {
data.notify = 2 
} else if (!this.setObj.notifyExist && this.setObj.notifyNotExist) {
data.notify = 3 
}
setdevicenotify(data).then(res => {
if (res.code === 200) {
this.$toast('操作成功')
this.deviceObj.notify = data.notify
this.$store.commit('set_child_obj', this.deviceObj)
} else {
this.$toast('操作失败')
if (type === 'openDoor') {
this.setObj.notifyExist = !this.setObj.notifyExist
} else if (type === 'closeDoor') {
this.setObj.notifyNotExist = !this.setObj.notifyNotExist
}
}
}).catch(() => {
this.$toast('操作失败')
if (type === 'exist') {
this.setObj.notifyExist = !this.setObj.notifyExist
} else if (type === 'notExist') {
this.setObj.notifyNotExist = !this.setObj.notifyNotExist
}
})
},
submitRefreshStatus () {
let data = {
did: this.deviceObj.id,
cmd: '3|0|0'
}
sendcommand(data).then(res => {
this.$toast('成功发送指令')
}).catch(() => {})
},
submitActivity () {

let data = {dids: [this.deviceObj.id], properties: [{key: 'isactivity', value: '0'}]}
if (this.activityObj.activity === true) {
if (this.activityObj.periodHour === '' && this.activityObj.periodMinute === '') {
this.activityObj.hintShow = true
this.activityObj.hintText = '请选择监测周期。'
return
}
if (this.activityObj.durationStart === '' || this.activityObj.durationEnd === '') {
this.activityObj.hintShow = true
this.activityObj.hintText = '请选择监测时段。'
return
}
let periodValue = 0
periodValue += this.activityObj.periodHour !== '' ? parseInt(this.activityObj.periodHour) * 3600 : 0
periodValue += this.activityObj.periodMinute !== '' ? parseInt(this.activityObj.periodMinute) * 60 : 0
let durationStart = parseInt(this.activityObj.durationStart) < 10 ? '0' + this.activityObj.durationStart + ':00' : this.activityObj.durationStart + ':00'
let durationEnd = parseInt(this.activityObj.durationEnd) < 10 ? '0' + this.activityObj.durationEnd + ':00' : this.activityObj.durationEnd + ':00'
data.properties[0].value = periodValue + '###' + durationStart + '###' + durationEnd
}
setdevice(data).then(res => {
if (res.code === 200) {
this.setting.isActivity = this.activityObj.activity
this.setting.periodHour = data.properties[0].value === '0' ? '' : this.activityObj.periodHour
this.setting.periodMinute = data.properties[0].value === '0' ? '' : this.activityObj.periodMinute
this.setting.durationStart = data.properties[0].value === '0' ? '' : this.activityObj.durationStart
this.setting.durationEnd = data.properties[0].value === '0' ? '' : this.activityObj.durationEnd

this.$store.commit('set_child_obj', this.deviceObj)
this.$toast('成功')
this.activityShow = false
} else {
this.$toast('失败')
}
}).catch(() => {
this.$toast('失败')
this.activityShow = false
})
},
submitOutputStatus (setObj) {
if (setObj.outputStatus === '') {
return
}
let data = {
did: this.deviceObj.id,
cmd: ''
}
if (setObj.outputStatus === 1) {
data.cmd = '1|0|0'
} else if (this.statusType1 === 2) {
data.cmd = '2|0|0'
}
sendcommand(data).then(res => {
this.setting.outputStatus = setObj.outputStatus
this.$toast('成功发送指令')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false
}).catch(() => {})
},
submitHeartbeatDuration (setObj) {
if (setObj.heartbeatDuration === '') {
return
}
let data = {
did: this.deviceObj.id,
cmd: '4|' + Math.floor(parseInt(setObj.heartbeatDuration) / 10) + '|0'
}
sendcommand(data).then(res => {
this.setting.heartbeatDuration = setObj.heartbeatDuration
this.$toast('成功发送指令')
this.$store.commit('set_child_obj', this.deviceObj)
this.setShow = false
}).catch(() => {})
},
submitSetList (item, index) {
let type = this.setListObj.type
let delIdx = item ? index : -1
if (type === 'phoneBook') {
this.submitPhoneBook(this.setListObj, delIdx)
} else if (type === 'fm') {
this.submitFM(this.setListObj, delIdx)
}
},
submitPhoneBook (setListObj, delIdx) {
let phoneBookList = this.clone(setListObj.phoneBookList)
if (delIdx !== -1) {

phoneBookList.splice(delIdx, 1)
} else {
if (setListObj.phoneBookObj.name === '') {
this.setListObj.hintText = '请输入姓名。'
this.setListObj.hintShow = true
return
} else if (setListObj.phoneBookObj.phone === '') {
this.setListObj.hintText = '请输入号码。'
this.setListObj.hintShow = true
return
}
setListObj.phoneBookObj.im = setListObj.phoneBookObj.im === '' ? '112' : setListObj.phoneBookObj.im
if (setListObj.editIdx !== -1) {

phoneBookList[this.setListObj.editIdx] = setListObj.phoneBookObj
} else {

phoneBookList.push(setListObj.phoneBookObj)
}
}

let data = {
imei: this.deviceObj.deviceid,
did: this.deviceObj.id,
method: 'phonebook',
command1: '',
command2: '',
command3: '',
command4: '',
command5: '',
reserved1: '',
reserved2: ''
}
phoneBookList.forEach((phoneBook, index) => {
let command = phoneBook.name + '|' + phoneBook.phone + '|' + phoneBook.icon + '|' + phoneBook.im
switch (index) {
case 0:
data.command1 = command
break
case 1:
data.command2 = command
break
case 2:
data.command3 = command
break
case 3:
data.command4 = command
break
case 4:
data.command5 = command
break
case 5:
data.reserved1 = command
break
case 6:
data.reserved2 = command
break
default:
break
}
})
sendcommandmessage(data).then(res => {
if (res.code === 200) {
this.setListObj.phoneBookList = phoneBookList
this.setting.phoneBookList = phoneBookList
this.$store.commit('set_child_obj', this.deviceObj)
this.$toast('成功')
this.setListObj.isList = true
} else {
this.$toast('失败')
}
}).catch(() => {
this.$toast('失败')
})
},
submitFM (setListObj, delIdx) {
let fmList = this.clone(setListObj.fmList)
if (delIdx !== -1) {

fmList.splice(delIdx, 1)
} else {
if (setListObj.fmObj.name === '') {
this.setListObj.hintText = '请输入电台名称。'
this.setListObj.hintText = true
return
} else if (setListObj.fmObj.frequency === '') {
this.setListObj.hintText = '请输入电台频率。'
this.setListObj.hintText = true
return
}
if (setListObj.editIdx !== -1) {

} else {

fmList.push(setListObj.fmObj)
}
}

let data = {
imei: this.deviceObj.deviceid,
did: this.deviceObj.id,
method: 'setfm',
command1: '',
command2: '',
command3: '',
command4: '',
command5: '',
reserved1: '',
reserved2: ''
}
fmList.forEach((fm, index) => {
let command = fm.name + '#' + fm.frequency
switch (index) {
case 0:
data.command1 = command
break
case 1:
data.command2 = command
break
case 2:
data.command3 = command
break
case 3:
data.command4 = command
break
case 4:
data.command5 = command
break
case 5:
data.reserved1 = command
break
case 6:
data.reserved2 = command
break
default:
break
}
})
sendcommandmessage(data).then(res => {
if (res.code === 200) {
this.setListObj.fmList = fmList
this.setting.fmList = fmList
this.$store.commit('set_child_obj', this.deviceObj)
this.$toast('成功')
this.setListObj.isList = true
} else {
this.$toast('失败')
}
}).catch(() => {
this.$toast('失败')
})
},
backList () {
this.setListObj.isList = true
},

getInfoText (item, category) {
let result = ''
if (item.type === 'batteryPercent') {
result = this.deviceObj.mainConfig.batteryPercent ? this.deviceObj.mainConfig.batteryPercent.value : ''
} else if (item.type === 'outputVol') {
result = this.deviceObj.mainConfig.outputVol ? this.deviceObj.mainConfig.outputVol.value : ''
} else if (item.type === 'voltage') {
result = this.getDeviceVoltage(this.deviceObj)
} else if (item.type === 'battery') {
result = this.getDeviceBattery(this.deviceObj)
} else if (item.type === 'temperature') {
result = this.getDeviceTemperature(this.deviceObj)
} else if (item.type === 'humidity') {
result = this.getDeviceHumidity(this.deviceObj)
} else if (item.type === 'signal') {
result = this.getSignal(this.deviceObj)
} else if (item.type.indexOf('probeTempHum') !== -1) {
result = this.getProbeTempHum(this.deviceObj, item.type, category)
}
return result
},
getTipInfoText (item) {
let result = ''
if (item.type === 'voltage') {
let voltage = this.getDeviceVoltage(this.deviceObj)
if (voltage !== '--' && voltage <= 2.4) {
result = ' 电量低！'
}
}
return result
},
getTimeText (item) {
let result = ''
if (item.type.indexOf('probeTempHum') !== -1) {
switch (item.type) {
case 'probeTempHum1':
result = this.deviceObj.mainConfig.temperature && this.deviceObj.mainConfig.temperature.time !== 0 ? new Date(this.deviceObj.mainConfig.temperature.time).format('yyyy-MM-dd hh:mm:ss') : ''
break
case 'probeTempHum2':
result = this.deviceObj.mainConfig.temperature2 && this.deviceObj.mainConfig.temperature2.time !== 0 ? new Date(this.deviceObj.mainConfig.temperature2.time).format('yyyy-MM-dd hh:mm:ss') : ''
break
case 'probeTempHum3':
result = this.deviceObj.mainConfig.temperature3 && this.deviceObj.mainConfig.temperature3.time !== 0 ? new Date(this.deviceObj.mainConfig.temperature3.time).format('yyyy-MM-dd hh:mm:ss') : ''
break
case 'probeTempHum4':
result = this.deviceObj.mainConfig.temperature4 && this.deviceObj.mainConfig.temperature4.time !== 0 ? new Date(this.deviceObj.mainConfig.temperature4.time).format('yyyy-MM-dd hh:mm:ss') : ''
break
}
}
return result
},

getDeviceVoltage (item) {
let result = '--'
if (item.mainConfig.batteryVol) {
let batteryVol = item.mainConfig.batteryVol.value
if (item.dtype === 402 || item.dtype === 404 || item.dtype === 505) {
result = Math.round((batteryVol / 1000) * 10) / 10
} else if (item.dtype === 503 || item.dtype === 504 || item.dtype === 506 || item.dtype === 507 ||
item.dtype === 508 || item.dtype === 509 || item.dtype === 510 || item.dtype === 511 ||
item.dtype === 904 || item.dtype === 905) {
result = batteryVol > 100 ? Math.round((batteryVol / 100) * 10) / 10 : Math.round(batteryVol * 10) / 10
} else {
result = batteryVol
}
}

return result
},

getDeviceBattery (item) {
let result = '--'
if (item.dtype === 901) {
result = item.battery
} else {
if (item.mainConfig.battery) {
result = item.mainConfig.battery.value
}
}

return result
},

getDeviceTemperature (item) {
let result = ''
result = item.mainConfig.temperature ? item.mainConfig.temperature.value : '--'

return result
},

getDeviceHumidity (item) {
let result = ''
result = item.mainConfig.humidity ? item.mainConfig.humidity.value : '--'

return result
},

getSignal (item) {
console.log(item)
let result = '--'
if (![402, 800].indexOf(this.deviceObj.dtype) >= 0 && this.deviceObj.isonline === 0) {
result = '离线'
} else {
if (item.mainConfig.signal) {
let signal = item.mainConfig.signal.value
if (signal === 0) {
result = '极弱'
} else if (signal === 1) {
result = '弱'
} else if (signal === 2) {
result = '一般'
} else if (signal === 3) {
result = '强'
} else if (signal === 4) {
result = '极好'
}
}
}
return result
},
getProbeTempHum (item, type, category) {
let result = ''
if (type === 'probeTempHum1') {
if (category === 'temperature') {
result = item.mainConfig.temperature && item.mainConfig.temperature.time !== 0 ? item.mainConfig.temperature.value : '--'
} else if (category === 'humidity') {
result = item.mainConfig.humidity && item.mainConfig.humidity.time !== 0 ? item.mainConfig.humidity.value : '--'
}
} else if (type === 'probeTempHum2') {
if (category === 'temperature') {
result = item.mainConfig.temperature2 && item.mainConfig.temperature2.time !== 0 ? item.mainConfig.temperature2.value : '--'
} else if (category === 'humidity') {
result = item.mainConfig.humidity2 && item.mainConfig.humidity2.time !== 0 ? item.mainConfig.humidity2.value : '--'
}
} else if (type === 'probeTempHum3') {
if (category === 'temperature') {
result = item.mainConfig.temperature3 && item.mainConfig.temperature3.time !== 0 ? item.mainConfig.temperature3.value : '--'
} else if (category === 'humidity') {
result = item.mainConfig.humidity3 && item.mainConfig.humidity3.time !== 0 ? item.mainConfig.humidity3.value : '--'
}
} else if (type === 'probeTempHum4') {
if (category === 'temperature') {
result = item.mainConfig.temperature4 && item.mainConfig.temperature4.time !== 0 ? item.mainConfig.temperature4.value : '--'
} else if (category === 'humidity') {
result = item.mainConfig.humidity4 && item.mainConfig.humidity4.time !== 0 ? item.mainConfig.humidity4.value : '--'
}
}
return result
},
getInfoTextStyle (item, category) {
let result = ''
if (item.type === 'outputVol' || item.type === 'voltage' || item.type === 'battery') {
result = 'color: #f78122' 
} else if (item.type === 'temperature') {
result = 'color: #07cb9b' 
} else if (item.type === 'humidity' || item.type === 'signal') {
result = 'color: #658efd' 
if (item.type === 'signal' && ![402, 800].indexOf(this.deviceObj.dtype) >= 0 && this.deviceObj.isonline === 0) {
result = 'color: red'
}
} else if (item.type === 'batteryVol' || item.type === 'batteryPercent') {
result = 'color: #30AFE1' 
} else if (item.type.indexOf('probeTempHum') !== -1) {
let mainConfig = this.deviceObj.mainConfig
let lastOnline = this.deviceObj.last_online
if (mainConfig.valueLastTime === 0) {
result = 'color: #6B7280'
} else {
if (item.type === 'probeTempHum1') {
if (category === 'temperature') {
result = mainConfig.temperature && Math.floor((new Date(lastOnline).getTime() - mainConfig.temperature.time) / 60000) <= 5 ? 'color: #658efd' : 'color: #6B7280'
} else if (category === 'humidity') {
result = mainConfig.humidity && Math.floor((new Date(lastOnline).getTime() - mainConfig.humidity.time) / 60000) <= 5 ? 'color: #658efd' : 'color: #6B7280'
}
} else if (item.type === 'probeTempHum2') {
if (category === 'temperature') {
result = mainConfig.temperature2 && Math.floor((new Date(lastOnline).getTime() - mainConfig.temperature2.time) / 60000) <= 5 ? 'color: #658efd' : 'color: #6B7280'
} else if (category === 'humidity') {
result = mainConfig.humidity2 && Math.floor((new Date(lastOnline).getTime() - mainConfig.humidity2.time) / 60000) <= 5 ? 'color: #658efd' : 'color: #6B7280'
}
} else if (item.type === 'probeTempHum3') {
if (category === 'temperature') {
result = mainConfig.temperature3 && Math.floor((new Date(lastOnline).getTime() - mainConfig.temperature3.time) / 60000) <= 5 ? 'color: #658efd' : 'color: #6B7280'
} else if (category === 'humidity') {
result = mainConfig.humidity3 && Math.floor((new Date(lastOnline).getTime() - mainConfig.humidity3.time) / 60000) <= 5 ? 'color: #658efd' : 'color: #6B7280'
}
} else if (item.type === 'probeTempHum4') {
if (category === 'temperature') {
result = mainConfig.temperature4 && Math.floor((new Date(lastOnline).getTime() - mainConfig.temperature4.time) / 60000) <= 5 ? 'color: #658efd' : 'color: #6B7280'
} else if (category === 'humidity') {
result = mainConfig.humidity4 && Math.floor((new Date(lastOnline).getTime() - mainConfig.humidity4.time) / 60000) <= 5 ? 'color: #658efd' : 'color: #6B7280'
}
}
}
} else {
result = 'color: #658efd'
}
return result
}
}
}



// WEBPACK FOOTER //
// ./src/components/device/NewSubDeviceDetail.vue